import { render, staticRenderFns } from "./SpecialCustomerForm.vue?vue&type=template&id=52a02e89&scoped=true&"
import script from "./SpecialCustomerForm.vue?vue&type=script&lang=js&"
export * from "./SpecialCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCustomerForm.vue?vue&type=style&index=0&id=52a02e89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a02e89",
  null
  
)

component.options.__file = "SpecialCustomerForm.vue"
export default component.exports